import React, {Component} from 'react';
import {Switch, Route} from 'react-router-dom';
import {connect} from 'react-redux';

import Header from 'header';
import MainPage from './main';
import Sidebar from 'components/sidebar';
import Footer from 'components/footer';

import Documents from './documents';
import DocumentDetail from './documents/detail';
import CreateDocument from './documents/create';
import Mailing from './mailing';

import CreateMail from './mailing/create';
import MailDetail from './mailing/detail';
import Users from './users';
import UserDetail from './users/detail';
import {loadUser} from 'redux/actions/auth';
import {loadStaffByUser} from 'redux/actions/portal/institutions';
import {routes} from './routes';

import Institutions from './institutions';
import InsitutionDetail from './institutions/detail';
import CreateInstitutions from './institutions/create';
import AddInstitutionService from './institutions/add-service';
import InstitutionServiceDetail from './institutions/service-detail';
import AddInstitutionPersonal from './institutions/add-personal';
import InstitutionPersonalDetail from './institutions/personal-detail';

import Services from './services';
import ServicesDetail from './services/detail';
import CreateService from './services/create';

import Personal from './personal';
import PersonalDetail from './personal/detail';
import CreatePersonal from './personal/create';

import Doctors from './doctors';
import DoctorDetail from './doctors/detail';
import CreateDoctor from './doctors/create';

import News from './news';
import NewsDetail from './news/detail';
import CreateNews from './news/create';

import {Content, ContentInner} from 'components/content';



const mapStateToProps = state => ({
  token: state.auth.get('token'),
  user: state.auth.get('user'),
  staff: state.institutions.get('currentUserInstitutions')
})

const mapDispatchToProps = dispatch => ({
  onLoad: () => dispatch(loadUser()),
  loadStaff: (id, role) => dispatch(loadStaffByUser(id, role))
})

class AdminRouter extends Component {

  componentDidMount() {
    if (this.props.token) {
      this.props.onLoad();
    }
    if(this.props.user && this.props.user.get('is_admin_institution')) {
      this.props.loadStaff(this.props.user.get('id'), 'is_admin')
    }
  }

  componentWillReceiveProps(nextProps) {
    if(nextProps.user && nextProps.user.get('is_admin_institution') && !nextProps.staff) {
      nextProps.loadStaff(nextProps.user.get('id'), 'is_admin')
    }
    if (window.innerWidth < 1200 && this.props.menuOpen === false) {
      this.props.toggleMobileAdminMenu();
    }
  }

  renderMenuLinks = (isAdminInstitution) => {
    return isAdminInstitution
      ? routes(isAdminInstitution, this.props.staff.getIn(['results', 0, 'institution']))
      : routes(isAdminInstitution)
  }

  renderAdminRoutes = () => {
    return (this.props.user.get('is_admin_institution') && !this.props.user.get('is_superuser'))
      ? <Route exact path="/admin/" component={Institutions}/>
      : [
          <Switch key="1">
          <Route exact path="/admin/" component={MainPage}/>,

            <Route exact path="/admin/documents" component={Documents} />,
            <Route exact path="/admin/documents/detail/:document_id" component={DocumentDetail} />,
            <Route exact path="/admin/documents/detail/:document_id/edit" component={CreateDocument} />,
            <Route exact path="/admin/documents/create" component={CreateDocument} />,
            <Route exact path="/admin/documents/:page" component={Documents} />,

            <Route exact path="/admin/mailing" component={Mailing} />,
            <Route exact path="/admin/mailing/detail/:mail_id" component={MailDetail} />,
            <Route exact path="/admin/mailing/detail/:mail_id/edit" component={CreateMail} />,
            <Route exact path="/admin/mailing/create/:document_id" component={CreateMail} />,
            <Route exact path="/admin/mailing/create/:document_id/:page" component={CreateMail} />,
            <Route exact path="/admin/mailing/:page" component={Mailing} />,
  
            <Route exact path="/admin/operators" component={Users} />,
            <Route exact path="/admin/operators/detail/:id" component={UserDetail} />,
            <Route exact path="/admin/operators/:page" component={Users} />,
  
            <Route exact path="/admin/news/create" component={CreateNews} />,
            <Route exact path="/admin/news/detail/:id/edit" component={CreateNews} />,
            <Route exact path="/admin/news" component={News}/>,
            <Route exact path="/admin/news/detail/:id" component={NewsDetail} />,
            <Route exact path="/admin/news/:page" component={News} />,
    
            <Route exact path="/admin/services" component={Services} />,
            <Route exact path="/admin/services/detail/:id" component={ServicesDetail} />,
            <Route exact path="/admin/services/create" component={CreateService} />,
            <Route exact path="/admin/services/:page" component={Services} />,
            <Route exact path="/admin/services/detail/:service_id/edit" component={CreateService} />,
         
            <Route exact path="/admin/personal" component={Personal} />,
            <Route exact path="/admin/personal/detail/:id" component={PersonalDetail} />,
            <Route exact path="/admin/personal/create" component={CreatePersonal} />,
            <Route exact path="/admin/personal/:page" component={Personal} />,
            <Route exact path="/admin/personal/detail/:personal_id/edit" component={CreatePersonal} />
          </Switch>
      ]
  }

  render() {

    if (!this.props.user || (this.props.user.get('is_admin_institution') && !this.props.staff)) {
      return null;
    }
    return (
      <div>
        <Header/>
        <Content>
          <Sidebar routes={this.renderMenuLinks(this.props.user.get('is_admin_institution') && !this.props.user.get('is_superuser'))} cabinet="Службовий кабінет"/>
          <ContentInner>
            <Switch>
              <Route exact path="/admin/institutions" component={Institutions} />
              <Route exact path="/admin/institutions/detail/:institution_id/edit" component={CreateInstitutions} />
              <Route path="/admin/institutions/detail/:id" component={InsitutionDetail} />
              <Route exact path="/admin/institutions/create" component={CreateInstitutions} />
              <Route exact path="/admin/institutions/:page" component={Institutions} />
              <Route exact path="/admin/institutions/:institution_id/service/:serviceInstitution_id" component={InstitutionServiceDetail} />
              <Route exact path="/admin/institutions/:institution_id/add-service" component={AddInstitutionService} />
              <Route exact path="/admin/institutions/:institution_id/edit-service/:service_id" component={AddInstitutionService} />
              <Route exact path="/admin/institutions/:institution_id/personal/:personalInstitution_id" component={InstitutionPersonalDetail} />
              <Route exact path="/admin/institutions/:institution_id/add-personal" component={AddInstitutionPersonal} />
              <Route exact path="/admin/institutions/:institution_id/edit-personal/:personal_id" component={AddInstitutionPersonal} />

              <Route exact path="/admin/doctors" component={Doctors} />
              <Route exact path="/admin/doctors/detail/:id" component={DoctorDetail} />
              <Route exact path="/admin/doctors/create" component={CreateDoctor} />
              <Route exact path="/admin/doctors/:page" component={Doctors} />
              <Route exact path="/admin/doctors/detail/:doctor_id/edit" component={CreateDoctor} />
              {this.renderAdminRoutes()}
            </Switch>
          </ContentInner>
        </Content>
        <Footer/>
      </div>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(AdminRouter);



// WEBPACK FOOTER //
// ./src/admin/index.js